import regionConfig from "../../../config/region.json"

const region = regionConfig.regions[regionConfig.defaultRegion]
const mapView = region.mapView

// Region and cross-page fly events retain legacy Leaflet zooms. MapLibre uses
// a 512 px world tile, so the same visual extent is one zoom level lower.
export const LEAFLET_TO_MAPLIBRE_ZOOM_SHIFT = -1

export function leafletZoomToMapLibre(zoom) {
  return Number(zoom) + LEAFLET_TO_MAPLIBRE_ZOOM_SHIFT
}

export const MAP_VIEW_POLICY = Object.freeze({
  defaultHome: Object.freeze({ ...mapView.defaultHome }),
  mapDefaultZoom: mapView.mapDefaultZoom,
  waterDefaultZoom: mapView.waterDefaultZoom
})

export function defaultMapView({ zoom = MAP_VIEW_POLICY.mapDefaultZoom } = {}) {
  return { ...MAP_VIEW_POLICY.defaultHome, zoom }
}
